import { useEffect, useMemo, useState } from 'react'

/**
 * Expects image URLs in priority order.
 * Returns the first loadable image, falling back if one fails.
 * Also handles null and undefined values.
 */

const useImagePrioritization = (imageUrls?: (string | null | undefined)[]) => {
  const urls = useMemo(() => {
    if (!imageUrls) return []
    return imageUrls.filter(Boolean) as string[]
  }, [imageUrls])

  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    setCurrentIndex(0)
  }, [imageUrls])

  const currentImageUrl: string | undefined = urls[currentIndex]

  const handleImageError = () => {
    if (currentIndex < urls.length - 1) {
      setCurrentIndex((prev) => prev + 1)
    } else {
      setCurrentIndex(-1)
    }
  }
  // Probably not the best way to do this, but it's the easiest way to check if the image is a placeholder image.
  const isPlaceholderImage = useMemo(() => currentImageUrl?.includes('component-image-placeholder'), [currentImageUrl])
  return {
    currentImageUrl,
    handleImageError,
    isPlaceholderImage,
  }
}

export default useImagePrioritization
